<template>
	<Transition name="fade">
		<screen-home v-if="$store.getters['screen'] == 'home' " class="pxrwwfgv-screen" />
		<screen-description v-else-if="$store.getters['screen'] == 'description' " class="pxrwwfgv-screen" />
		<screen-video v-else-if="$store.getters['screen'] == 'startvideo' " class="pxrwwfgv-screen" startVideo />
		<screen-sikvidek v-else-if="$store.getters['screen'] == 'sikvidek' " class="pxrwwfgv-screen" />
		<screen-dombvidek v-else-if="$store.getters['screen'] == 'dombvidek' " class="pxrwwfgv-screen"/>
		<screen-video v-else-if="$store.getters['screen'] == 'endvideo' " class="pxrwwfgv-screen"/>
	</Transition>
</template>

<script setup >
	import {onMounted, onBeforeUnmount, watch, computed} from 'vue';
	import {useStore} from 'vuex';
	import { usePointer } from '@vueuse/core';

	import ScreenHome from '@/components/screens/ScreenHome.vue';
	import ScreenDescription from '@/components/screens/ScreenDescription.vue';
	import ScreenSikvidek from '@/components/screens/ScreenSikvidek.vue';
	import ScreenDombvidek from '@/components/screens/ScreenDombvidek.vue';
	import ScreenVideo from '@/components/screens/ScreenVideo.vue';

	const store = useStore();

	//dragging
	const pointer = usePointer();

	const pointerCoords = computed(() => {
		return [pointer.x.value, pointer.y.value];
	});

	const handlePointerUp = (event) => {
		if(store.getters['isDragging']){
			store.dispatch('stopDrag', [event.clientX, event.clientY]);
		}
	};

	watch(pointerCoords, () =>{
		if(store.getters['isDragging']){
			store.dispatch('moveDrag', pointerCoords.value);
		}
	});

	// Lifecycle hooks
	onMounted(() => {
		window.addEventListener('pointerup', handlePointerUp);
	});

	onBeforeUnmount(() => {
		window.removeEventListener('pointerup', handlePointerUp);
	});
</script>

<style scoped>
	.pxrwwfgv-screen {
		display: flex;
		justify-content: center;
		align-items: center;
		position: absolute;
		width: 100%;
		height: 100%;
		top: 0px;
		left: 0px;
		overflow: hidden;
		background-color: var(--color-light-blue);
	}
</style>